
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Menu from '../../../element/ui/core/menu';
import Padding from '../../../element/icons/padding';


import restrictNumber from '../../../utils/restrictNumber';
import {
  ANNOTATION_OPTION_POPUP_MIN_WIDTH,
  StyledHeadline,
  StyledOptionField,
  StyledOptionStack,
  StyledSpacedOptionFields,
  StyledIconWrapper,
  StyledOptionPopupContent,
} from '../../../components/common/AnnotationOptions/AnnotationOptions.styled';
import Slider from '../../../components/common/Slider';

const WatermarkPadding = ({ watermark, saveWatermark, t }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openOptionPopup = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const closeOptionPopup = () => {
    setAnchorEl(null);
  };

  const updatePadding = (newPadding) => {
    saveWatermark({ padding: restrictNumber(newPadding, 0, 100) });
  };

  const currentPadding = watermark.padding;

  return (
    <>
      <StyledIconWrapper
        className="respark_watermark-padding-triggerer"
        title={t('padding')}
        onClick={openOptionPopup}
      >
        <Padding size={18} />
      </StyledIconWrapper>
      <Menu
        className="respark_watermark-padding-popup"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeOptionPopup}
        position="top"
        containerProps={{
          style: { minWidth: ANNOTATION_OPTION_POPUP_MIN_WIDTH },
        }}
      >
        <StyledOptionPopupContent>
          <StyledSpacedOptionFields className="respark_annotation-option-panel">
            <StyledHeadline>{t('padding')}</StyledHeadline>
            <StyledOptionStack>
              <StyledOptionField>
                <Slider
                  width="100%"
                  annotation="px"
                  onChange={updatePadding}
                  value={currentPadding}
                />
              </StyledOptionField>
            </StyledOptionStack>
          </StyledSpacedOptionFields>
        </StyledOptionPopupContent>
      </Menu>
    </>
  );
};

WatermarkPadding.propTypes = {
  watermark: PropTypes.instanceOf(Object).isRequired,
  saveWatermark: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default WatermarkPadding;
